<div>
    <h3 name="subscriptionTitle6">{{'REGISTRATION.STEP.ACCOUNT_CREATION.FIRST_QUESTION' | translate}}</h3>
    <ul class="row no-margin-padding">
        <li class="col-md-6 unstyle">
            <div class="choice" (click)="filtering('helped')" [ngClass]="{'selected':accountType==='helped'}">
                <mat-icon name="account-creation-isHelped" class="icon-choice" aria-hidden="true">person</mat-icon>
            </div>
            <h6 class="h6-choice">{{'REGISTRATION.STEP.ACCOUNT_CREATION.WATCH_HELPED' | translate}}</h6>
        </li>
        <li class="col-md-6 unstyle">
            <div class="choice" (click)="filtering('helper')" [ngClass]="{'selected':accountType==='helper'}">
                <mat-icon name="account-creation-isHelper" class="icon-choice" aria-hidden="true">people</mat-icon>
            </div>
            <h6 class="h6-choice">{{'REGISTRATION.STEP.ACCOUNT_CREATION.WATCH_HELPER' | translate}}</h6>
        </li>
    </ul>
</div>
<div *ngIf="accountType !== undefined" class="formulaire">
    <form [formGroup]="profileForm">
        <ng-container *ngIf="accountType==='helped';else helperPart">
            <h4>{{'REGISTRATION.STEP.ACCOUNT_CREATION.YOUR_ACCOUNT' | translate}}</h4>
            <div class="row">
                <div class="col-md-12">
                    <span>{{'COMMON.CIVILITY'|translate}}
                    </span>
                </div>
                <div class="col-md-12 col-sm-12">
                    <div class="form-group">
                        <app-civility-radio-button formControlName="helpedCivility" [isCreation]="true">
                        </app-civility-radio-button>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <mat-form-field class="full-width">
                        <mat-label>{{'COMMON.USER_INFO.FIRST_NAME' | translate}}</mat-label>
                        <input matInput id="account-creation-helped-firstName" name="given-name"
                            autocomplete="given-name" class="full-width" formControlName="helpedFirstName">
                        <mat-error *ngIf="!isValid('helpedFirstName')">
                            {{errors.firstName | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6  col-sm-12">
                    <mat-form-field class="full-width">
                        <mat-label>{{'COMMON.USER_INFO.LAST_NAME' | translate}}</mat-label>
                        <input matInput id="account-creation-helped-lastName" class="marg-left" name="family-name"
                            autocomplete="family-name" class="full-width" formControlName="helpedLastName">
                        <mat-error *ngIf="!isValid('helpedLastName')">
                            {{errors.lastName | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-12  col-sm-12">
                    <mat-form-field class="full-width">
                        <mat-label>{{'REGISTRATION.CARRIER.EMAIL' | translate}}</mat-label>
                        <input matInput name="account-creation-email" autocomplete="email" type="email"
                            class="full-width" formControlName="helpedEmail">
                        <mat-error *ngIf="!isValid('helpedEmail')">
                            {{errors.email | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-12  col-sm-12">
                    <div class="form-group">
                        <mat-checkbox name="account-creation-randomPassword" formControlName="autoGeneratedPassword"
                            (click)="autoGeneratedPasswordChanged(true)">
                            {{'REGISTRATION.STEP.ACCOUNT_CREATION.AUTO_GENERATED' |translate}}
                        </mat-checkbox>
                    </div>
                </div>
                <div formGroupName="passwordGroup" *ngIf="!profileForm.get('autoGeneratedPassword').value">
                    <mat-form-field class="col-md-6 col-sm-6">
                        <mat-label>{{'REGISTRATION.STEP.ACCOUNT_CREATION.PASSWORD' | translate}}</mat-label>
                        <input name="account-creation-password" matInput autocomplete="new-password" type="password"
                            formControlName="password" class="full-width" [type]="hide ? 'password' : 'text'">
                        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
                        <mat-error> {{getPasswordError() | translate}}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="col-md-6 col-sm-6">
                        <mat-label>{{'REGISTRATION.STEP.ACCOUNT_CREATION.CONFIRM_PASSWORD' | translate}}</mat-label>
                        <input name="account-creation-password-confirm" matInput autocomplete="new-password"
                            type="password" formControlName="confirmPassword" [errorStateMatcher]="matcher"
                            class="full-width" [type]="hide ? 'password' : 'text'">
                        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
                        <mat-error>
                            {{errors.confirmPassword | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6  col-sm-6">
                    <mat-form-field class="full-width" floatLabel="always">
                        <mat-label>{{'COMMON.USER_INFO.PHONE_NUMBER' | translate}}</mat-label>
                        <app-phone name="account-creation-phone" formControlName="helpedPhoneNumber"
                            autocomplete="account-creation-phone">
                        </app-phone>
                        <mat-error name="errorUserPhone" *ngIf="!isValid('helpedPhoneNumber');">
                            {{ getPhoneNumberError('helpedPhoneNumber') | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-8  col-sm-8 ">
                    <mat-form-field class="full-width">
                        <mat-label>{{'COMMON.USER_INFO.ADDRESS' | translate}}</mat-label>
                        <app-address-autocomplete name="address" formControlName="helpedAddress"
                            (placeChanged)="placeChanged($event, 'helpedAddress')"></app-address-autocomplete>
                        <mat-error *ngIf=" !isValid('helpedAddress')">
                            {{errors.address | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4  col-sm-4 " *ngIf="itemConfig.alreadyOwn===false">
                    <div class="col-md-12">
                        <span>{{'REGISTRATION.STEP.ACCOUNT_CREATION.DELIVERY_ADDRESS'|translate}}</span>
                    </div>
                    <div class="col-md-12">
                        <mat-radio-group name="deliveryOptions" formControlName="addressRadio"
                            (change)="updateProfilForm()">
                            <mat-radio-button name="account-creation-yes-delivery" value="yes">
                                {{'COMMON.YES'|translate}}
                            </mat-radio-button>
                            <mat-radio-button name="account-creation-no-delivery" style="margin-left: 2%" value="no">
                                {{'COMMON.NO'|translate}}
                            </mat-radio-button>
                            <mat-error *ngIf="!isValid('addressRadio')">
                                {{errors.addressRadio | translate}}
                            </mat-error>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div *ngIf="otherAddress" class="col-md-12">
                    <fieldset class="row no-gutters top15 bottom15 ">
                        <legend>{{'REGISTRATION.FORM.DELIVERY_ADDRESS' |translate}}</legend>
                        <div class="col-md-6 col-sm-12 ">
                            <mat-form-field class="full-width">
                                <mat-label>{{'REGISTRATION.STEP.ACCOUNT_CREATION.RECIPIENT_FIRSTNAME' |
                                    translate}}</mat-label>
                                <input matInput id="account-creation-delivery-firstName" name="given-name"
                                    autocomplete="given-name" formControlName="recipientFirstName" class="full-width">
                                <mat-error *ngIf="!isValid('recipientFirstName')">
                                    {{errors.firstName | translate}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6  col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>{{'REGISTRATION.STEP.ACCOUNT_CREATION.RECIPIENT_LASTNAME' |
                                    translate}}</mat-label>
                                <input matInput id="account-creation-delivery-lastName" name="family-name"
                                    autocomplete=" family-name" formControlName="recipientLastName" class="marg-left"
                                    class="full-width">
                                <mat-error *ngIf="!isValid('recipientLastName')">
                                    {{errors.lastName | translate}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-12  col-sm-12 ">
                            <mat-form-field class="full-width">
                                <mat-label>{{'REGISTRATION.STEP.ACCOUNT_CREATION.RECIPIENT_ADDRESS' |
                                    translate}}</mat-label>
                                <app-address-autocomplete id="deliveryAddress" formControlName="recipientAddress"
                                    name="account-creation-delivery-address"
                                    (placeChanged)="placeChanged($event, 'recipientAddress')">
                                </app-address-autocomplete>
                                <mat-error *ngIf="!isValid('recipientAddress')">
                                    {{errors.address | translate}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </fieldset>
                </div>
            </div>
        </ng-container>
        <ng-template #helperPart>
            <h4>{{'REGISTRATION.STEP.ACCOUNT_CREATION.YOUR_ACCOUNT' | translate}}</h4>
            <div class="row">
                <div class="col-md-12">
                    <span>{{'COMMON.CIVILITY'|translate}}
                    </span>
                </div>
                <div class="col-md-12 col-sm-12">
                    <div class="form-group">
                        <app-civility-radio-button formControlName="helperCivility" [isCreation]="true">
                        </app-civility-radio-button>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <mat-form-field class="full-width">
                        <mat-label>{{'COMMON.USER_INFO.FIRST_NAME' | translate}}</mat-label>
                        <input matInput id="account-creation-helper-firstName" name="given-name"
                            autocomplete="given-name" formControlName="helperFirstName" class="full-width">
                        <mat-error *ngIf="!isValid('helperFirstName')">
                            {{errors.firstName | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6  col-sm-12">
                    <mat-form-field class="full-width">
                        <mat-label>{{'COMMON.USER_INFO.LAST_NAME' | translate}}</mat-label>
                        <input matInput id="account-creation-helper-lastName" name="family-name"
                            autocomplete="family-name" formControlName="helperLastName" class="marg-left"
                            class="full-width">
                        <mat-error *ngIf="!isValid('helperLastName')">
                            {{errors.lastName | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-12  col-sm-12">
                    <mat-form-field class="full-width">
                        <mat-label>{{'REGISTRATION.CARRIER.EMAIL' | translate}}</mat-label>
                        <input matInput name="account-creation-email" autocomplete="email" type="email"
                            formControlName="helperEmail" class="full-width">
                        <mat-error>
                            {{errors.email | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-12  col-sm-12">
                    <div class="form-group">
                        <mat-checkbox name="account-creation-randomPassword" formControlName="autoGeneratedPassword"
                            (click)="autoGeneratedPasswordChanged(true)">
                            {{'REGISTRATION.STEP.ACCOUNT_CREATION.AUTO_GENERATED' |translate}}
                        </mat-checkbox>
                    </div>
                </div>
                <div formGroupName="passwordGroup" *ngIf="!profileForm.get('autoGeneratedPassword').value">
                    <mat-form-field class="col-md-6 col-sm-6">
                        <mat-label>{{'REGISTRATION.STEP.ACCOUNT_CREATION.PASSWORD'|translate}}</mat-label>
                        <input name="account-creation-password" matInput autocomplete="new-password" type="password"
                            formControlName="password" class="full-width" [type]="hide ? 'password' : 'text'">
                        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
                        <mat-error> {{getPasswordError() | translate}}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="col-md-6 col-sm-6">
                        <mat-label>{{'REGISTRATION.STEP.ACCOUNT_CREATION.CONFIRM_PASSWORD'|translate}}</mat-label>
                        <input name="account-creation-password-confirm" matInput autocomplete="new-password"
                            type="password" formControlName="confirmPassword" [errorStateMatcher]="matcher"
                            class="full-width" [type]="hide ? 'password' : 'text'">
                        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
                        <mat-error>
                            {{errors.confirmPassword | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6  col-sm-6">
                    <mat-form-field class="full-width" floatLabel="always">
                        <mat-label>{{'COMMON.USER_INFO.PHONE_NUMBER' | translate}}</mat-label>
                        <app-phone name="account-creation-phone" formControlName="helperPhoneNumber"></app-phone>
                        <mat-error name="errorUserPhone" *ngIf="!isValid('helperPhoneNumber');">
                            {{ getPhoneNumberError('helperPhoneNumber') | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <h4>{{'REGISTRATION.STEP.ACCOUNT_CREATION.USER_ACCOUNT' | translate}}</h4>
            <div class="row">
                <div class="col-md-12">
                    <span>{{'COMMON.CIVILITY'|translate}}
                    </span>
                </div>
                <div class="col-md-12 col-sm-12">
                    <app-civility-radio-button formControlName="helpedCivility" [isCreation]="true">
                    </app-civility-radio-button>
                </div>
                <div class="col-md-6 col-sm-12">
                    <mat-form-field class="full-width">
                        <mat-label>{{'COMMON.USER_INFO.FIRST_NAME' | translate}}</mat-label>
                        <input matInput id="account-creation-helped-firstName" name="given-name"
                            autocomplete=" given-name" formControlName="helpedFirstName" class="full-width">
                        <mat-error *ngIf="!isValid('helpedFirstName')">
                            {{errors.firstName | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6  col-sm-12">
                    <mat-form-field class="full-width">
                        <mat-label>{{'COMMON.USER_INFO.LAST_NAME' | translate}}</mat-label>
                        <input matInput id="account-creation-helped-lastName" name="family-name"
                            autocomplete="family-name" class="marg-left" class="full-width"
                            formControlName="helpedLastName">
                        <mat-error *ngIf="!isValid('helpedLastName')">
                            {{errors.lastName | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-8  col-sm-8 ">
                    <mat-form-field class="full-width">
                        <mat-label>{{'COMMON.USER_INFO.ADDRESS' | translate}}</mat-label>
                        <app-address-autocomplete name="address" formControlName="helpedAddress"
                            (placeChanged)="placeChanged($event, 'helpedAddress')"></app-address-autocomplete>
                        <mat-error *ngIf="!isValid('helpedAddress')">
                            {{errors.address | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4  col-sm-4 " *ngIf="itemConfig.alreadyOwn===false">
                    <div class="col-md-12">
                        <span>{{'REGISTRATION.STEP.ACCOUNT_CREATION.DELIVERY_ADDRESS'|translate}}
                        </span>
                    </div>
                    <div class="col-md-12">
                        <mat-radio-group name="deliveryOptions" formControlName="addressRadio"
                            (change)="updateProfilForm()">
                            <mat-radio-button name="account-creation-yes-delivery" value="yes">
                                {{'COMMON.YES'|translate}}
                            </mat-radio-button>
                            <mat-radio-button name="account-creation-no-delivery" style="margin-left: 2%" value="no">
                                {{'COMMON.NO'|translate}}
                            </mat-radio-button>
                            <mat-error *ngIf="!isValid('addressRadio')">
                                {{errors.addressRadio | translate}}
                            </mat-error>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div *ngIf="otherAddress" class="col-md-12">
                    <fieldset class="row no-gutters top15 bottom15 ">
                        <legend>{{'REGISTRATION.FORM.DELIVERY_ADDRESS' |translate}}</legend>
                        <div class="col-md-6 col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>{{'COMMON.USER_INFO.FIRST_NAME' | translate}}</mat-label>
                                <input id="account-creation-delivery-firstName" matInput name="given-name"
                                    autocomplete="given-name" formControlName="recipientFirstName" class="full-width">
                                <mat-error *ngIf="!isValid('recipientFirstName')">
                                    {{errors.firstName | translate}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>{{'COMMON.USER_INFO.LAST_NAME' | translate}}</mat-label>
                                <input matInput id="account-creation-delivery-lastName" name="family-name"
                                    autocomplete="family-name" formControlName="recipientLastName" class="marg-left"
                                    class="full-width">
                                <mat-error *ngIf="!isValid('recipientLastName')">
                                    {{errors.lastName | translate}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-12 col-sm-12 ">
                            <mat-form-field class="full-width">
                                <mat-label>{{'REGISTRATION.STEP.ACCOUNT_CREATION.RECIPIENT_ADDRESS' |
                                    translate}}</mat-label>
                                <app-address-autocomplete id="deliveryAddress" formControlName="recipientAddress"
                                    name="account-creation-delivery-address"
                                    (placeChanged)="placeChanged($event, 'recipientAddress')">
                                </app-address-autocomplete>
                                <mat-error *ngIf="!isValid('recipientAddress')">
                                    {{errors.address | translate}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </fieldset>
                </div>
            </div>
        </ng-template>

    </form>

</div>
<div class="row">
    <div class="col-md-12 controls-button">
        <button mat-stroked-button color="primary" (click)="previous() ">
            {{'COMMON.BACK' | translate}}
        </button>
        <button name="goNext6" mat-raised-button [disabled]="!accountType || !validateSubmission"
            class="mat-primary pull-right" (click)="onSubmit()">
            {{'COMMON.CONTINUE' | translate}}
        </button>
    </div>
    <div class="col-md-12">
        <p class="mention">
            {{'REGISTRATION.STEP.PAYMENT.PERSONAL_DATA' | translate }} <a href="mailto:contact@co-assist.fr">
                contact&#64;co-assist.fr </a>
        </p>
    </div>
</div>